import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../lib/axiosInstance';
import { AxiosError } from 'axios';
import {
  AppErrorResponse,
  BaseModel,
  ProductModel,
  SKUOrderQuantityModel,
} from '../types';

export const MRS_API = '/stock/mrs';

export function useUploadMRFiles() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { id?: string; formData: FormData }) => {
      return await axiosInstance.putForm(
        `${MRS_API}/${data.id}/upload`,
        data.formData,
      );
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useDeleteMRFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return await axiosInstance.delete(`${MRS_API}/files?ids=${id}`);
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useFetchProderProducts(proderId: number | null | undefined) {
  return useQuery<ProductModel[], AxiosError<AppErrorResponse>>({
    queryKey: [proderId],
    enabled: proderId !== null || false,
    queryFn: async () => {
      const { data } = await axiosInstance.get<ProductModel[]>(
        `/proders/${proderId}/products`,
      );
      return data;
    },
  });
}

export function useFetchProderSKUS(proderCode: string | null | undefined) {
  return useQuery<BaseModel[], AxiosError<AppErrorResponse>>({
    queryKey: [proderCode],
    enabled: proderCode !== null || false,
    queryFn: async () => {
      const { data } = await axiosInstance.get<BaseModel[]>(
        `/prod/skus/proder`,
        {
          params: {
            proder: proderCode,
          },
        },
      );
      return data;
    },
  });
}
